import { createApp } from "vue";
// import "vant/lib/index.css";
import "element-plus/dist/index.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./permission";
import 'element-plus/theme-chalk/dark/css-vars.css'
import "@/style/index.scss";
import "@/style/global.scss";
import "@/style/reset.css";
import InfiniteScroll from "element-plus";
import Container from "@/views/operate/components/Container.vue";
import CourseItem from "@/views/operate/components/index/CourseItem.vue";
import TLoading from "@/views/operate/components/TLoading.vue";
import { i18n } from "./language/local"; 
// import VConsole from "vconsole";
// const Vconsole = new VConsole();

import { vCdnSimple as vCdn } from '@/directives/vCdn';

const app = createApp(App)
  .component("Container", Container)
  .component("CourseItem", CourseItem)
  .component("TLoading", TLoading) 
  .use(i18n)
  .use(InfiniteScroll)
  .use(store)
  .use(router);

  app.directive('cdn', vCdn);
app.mount("#app"); 